export default __webpack_public_path__ + "static/media/approval.8b841bf1.svg";